import React, { useState } from 'react';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';

// Schermata a schermo intero, mostrata al posto di qualunque pagina quando user.primo_accesso
// è true (login con password condivisa/temporanea impostata dallo staff, es. import CSV tesseramenti).
export default function CambiaPasswordObbligatoria() {
  const { user, updateUser, logout } = useAuth();
  const [form, setForm] = useState({ passwordAttuale: '', nuovaPassword: '', conferma: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.nuovaPassword !== form.conferma) { setError('Le due password non coincidono'); return; }
    if (form.nuovaPassword.length < 8) { setError('La nuova password deve essere di almeno 8 caratteri'); return; }
    setLoading(true);
    try {
      await api.post('/auth/cambia-password', { passwordAttuale: form.passwordAttuale, nuovaPassword: form.nuovaPassword });
      updateUser({ primo_accesso: false });
    } catch (err) {
      setError(err.response?.data?.error || 'Errore');
    } finally { setLoading(false); }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>B-CHEERS ASD</div>
        <div style={s.sub}>PRIMO ACCESSO</div>
        <p style={s.desc}>Ciao <strong style={{ color:'#F4600C' }}>{user?.nome}</strong>, per motivi di sicurezza devi impostare una password personale prima di continuare.</p>
        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.field}>
            <label style={s.label}>PASSWORD ATTUALE</label>
            <input style={s.input} type="password" value={form.passwordAttuale} onChange={set('passwordAttuale')} placeholder="Quella comunicata dallo staff" required />
          </div>
          <div style={s.field}>
            <label style={s.label}>NUOVA PASSWORD</label>
            <input style={s.input} type="password" value={form.nuovaPassword} onChange={set('nuovaPassword')} placeholder="Minimo 8 caratteri" required />
          </div>
          <div style={s.field}>
            <label style={s.label}>CONFERMA NUOVA PASSWORD</label>
            <input style={s.input} type="password" value={form.conferma} onChange={set('conferma')} placeholder="Ripeti la password" required />
          </div>
          {error && <div style={s.error}>{error}</div>}
          <button type="submit" style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
            {loading ? 'SALVATAGGIO...' : 'IMPOSTA PASSWORD E CONTINUA'}
          </button>
        </form>
        <div style={s.footer}>
          <button type="button" onClick={logout} style={s.linkBtn}>Esci</button>
        </div>
      </div>
    </div>
  );
}

const s = {
  page:   { minHeight:'100vh', background:'var(--bg)', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px' },
  card:   { background:'var(--bg)', border:'1px solid var(--border)', borderRadius:'16px', padding:'48px 40px', width:'100%', maxWidth:'420px' },
  logo:   { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', color:'#F4600C', letterSpacing:'3px', textAlign:'center', marginBottom:'4px' },
  sub:    { fontSize:'var(--font-size-xs)', fontWeight:'700', color:'var(--text-dim)', letterSpacing:'2px', textAlign:'center', marginBottom:'24px' },
  desc:   { color:'var(--text-dim)', fontSize:'var(--font-size-sm)', marginBottom:'24px', lineHeight:'1.6', textAlign:'center' },
  form:   { display:'flex', flexDirection:'column', gap:'16px' },
  field:  { display:'flex', flexDirection:'column', gap:'7px' },
  label:  { fontSize: 'var(--font-size-xs)', letterSpacing:'2px', fontWeight:'700', color:'var(--text-dim)' },
  input:  { background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'10px', padding:'12px 14px', color:'var(--text)', fontSize:'var(--font-size-sm)', outline:'none', width:'100%', boxSizing:'border-box' },
  error:  { background:'#EF444420', border:'1px solid #EF444440', borderRadius:'8px', padding:'10px 14px', color:'#EF4444', fontSize:'var(--font-size-sm)', fontWeight:'600' },
  btn:    { background:'#F4600C', color:'#fff', border:'none', borderRadius:'10px', padding:'14px', fontSize:'var(--font-size-sm)', fontWeight:'700', cursor:'pointer', letterSpacing:'1px', marginTop:'4px' },
  footer: { textAlign:'center', marginTop:'20px', fontSize:'var(--font-size-sm)', color:'var(--text-dim)' },
  linkBtn:{ background:'none', border:'none', color:'#F4600C', textDecoration:'none', fontWeight:'700', cursor:'pointer', fontSize:'var(--font-size-sm)' },
};
